import React from "react";
import { useTranslation } from "react-i18next";

import Navigation from "../../Components/Navigation/Navigation";
import AiHero from "./AiHero/AiHero";
import Form from "../../Components/Form/Form";
import AiAbout from "./AiAbout/AiAbout";
import AiPackages from "./AiPackages/AiPackages";
import Footer from "../../Components/Footer/Footer";

const AiBot = () => {
  const { t } = useTranslation();
  return (
    <>
      <Navigation
        navItems={[
          {
            label: t("navigation.about"),
            sectionId: "ai_about_section",
          },
          {
            label: "Modules",
            sectionId: "ai_packages_section",
          },
          {
            label: t("navigation.contact"),
            sectionId: "form_section",
          },
          {
            type: "link",
            label: t("navigation.back"),
            path: "/",
          },
        ]}
      />
      <AiHero />
      <AiAbout />
      <AiPackages />
      <Form />
      <Footer />
    </>
  );
};

export default AiBot;
